module.exports = __webpack_public_path__ + "img/location_main.dd6d185f.png";